import { Icon, Modal, useLoad } from '@hive/ui';
import { useState } from 'react';
import { useLocation } from 'react-router';
import { useT } from '../i18n';
import type { AskContext } from '../lib/ai';
import { answersStatus } from '../lib/answers';
import { useSession } from '../lib/session';
import { AskPanel } from '../screens/ai/AskPanel';

const UUID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

/** O contexto da tela atual: o ativo em /assets/:id, o alerta em /alerts?id=. */
export function contextOf(pathname: string, search: string): AskContext {
  const c: AskContext = { kind: 'screen', path: pathname };
  const asset = pathname.match(/^\/assets\/([^/]+)/)?.[1];
  if (asset && UUID.test(asset)) c.assetId = asset;
  const alert = new URLSearchParams(search).get('id');
  if (pathname === '/alerts' && alert && UUID.test(alert)) c.alertId = alert;
  return c;
}

/** Chat embutido (O1): "Perguntar à IA" em qualquer tela, com o que está aberto como evidência; o Hive responde primeiro. */
export function AskDrawer() {
  const t = useT();
  const s = useSession();
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  // R01-14: o botão aparece também sem modelo de IA — o próprio Hive responde o que sabe
  const status = useLoad(() => answersStatus(s.api).catch(() => null), [s.api]);
  if (!status.data?.available && !status.data?.model) return null;
  return (
    <>
      {/* com um assistente na tela o botão encolhe para o ícone (extra.css): o nome fica no span, para o leitor de tela, e na dica */}
      <button type="button" className="ask-fab btn btn-primary" onClick={() => setOpen(true)} aria-haspopup="dialog" title={t('chat.open')}>
        <Icon name="chart" size="sm" />
        <span className="ask-fab-label">{t('chat.open')}</span>
      </button>
      {open && (
        <Modal title={t('chat.title')} onClose={() => setOpen(false)} size="lg">
          <AskPanel context={contextOf(loc.pathname, loc.search)} title={t('chat.subtitle')} />
        </Modal>
      )}
    </>
  );
}
